import { ca } from '@cian/analytics';

interface ITrackDeleteOfferFromComparison {
  offerId: number;
  label: string;
}

export const trackDeleteOfferFromComparison = ({ offerId, label }: ITrackDeleteOfferFromComparison) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Compare',
    action: 'Remove',
    label,
    products: [
      {
        id: offerId,
        offerType: 'offer',
      },
    ],
  });
};
